const { toggleAttribute, toggleClass } = require('../../common')

module.exports = () => {
  const toggleButton = document.querySelector('#toggle-translations-mobile-btn')
  const container = document.querySelector('#translations-mobile')

  const toggleSearch = (event) => {
    event.preventDefault()
    toggleAttribute(toggleButton, 'aria-expanded')
    toggleClass(toggleButton, 'is-active')
    toggleClass(container, 'js-show')
  }

  const addEvents = () => {
    ;[toggleButton].forEach((elem) => {
      elem.addEventListener('click', toggleSearch)
    })
  }

  if (toggleButton) addEvents()
}
